import { Request } from '../../../../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../../../../httpClient/serverApi/types/IResponse';
import {IPrepExtensionsSiteSettings} from '../../../../../../settings/types/ISiteSettingsForSiteAdmin';

export interface IUpdatePrepExtensionsSiteSettingsParams {
  prepExtensionsSiteSettings: IPrepExtensionsSiteSettings;
}

export type IUpdatePrepExtensionsSiteSettingsResult = IResult & IPrepExtensionsSiteSettings;

export class UpdatePrepExtensionsSiteSettingsRequest extends Request<IUpdatePrepExtensionsSiteSettingsParams, IUpdatePrepExtensionsSiteSettingsResult> {
  constructor(params: IUpdatePrepExtensionsSiteSettingsParams) {
    super('updatePrepExtensionsSiteSettings', params);
  }
}
